export enum PetFlags {
    NoRename = 0x1,
    WellKnown = 0x2,
    NotAccountWide = 0x4,
    Capturable = 0x8,
    NotTradable = 0x10,
    HideFromJournal = 0x20,
    LegacyAccountUnique = 0x40,
    CantBattle = 0x80,
    HordeOnly = 0x100,
    AllianceOnly = 0x200,
    Boss = 0x400,
    RandomDisplay = 0x800,
    NoLicenseRequired = 0x1000,
    AddsAllowedWithBoss = 0x2000,
    HideUntilLearned = 0x4000,
    MatchPlayerHighPetLevel = 0x8000,
    NoWildPetAddsAllowed = 0x10000,
}
